import type { ComponentProps, FunctionComponent } from 'react';

import { PlayerProvider, PlayerProviderProps } from '@suntex.fim/player';

type WithPlayerProps = Pick<
  PlayerProviderProps,
  'isPreview' | 'playerId' | 'teamId'
>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function wrapForPlayer<C extends FunctionComponent<any>>(Component: C) {
  type OriginalProps = ComponentProps<C>;
  type WrappedProps = Omit<OriginalProps, keyof WithPlayerProps> &
    WithPlayerProps;

  return ({
    isPreview,
    playerId,
    teamId,
    ...props
  }: WrappedProps): JSX.Element => {
    return (
      <PlayerProvider {...{ isPreview, playerId, teamId }}>
        <Component {...(props as OriginalProps)} />
      </PlayerProvider>
    );
  };
}
